import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { addItemToExistingAssetRentRequest } from '@api/assetsRent';

import { IAddItemToExistingAssetRentRequestDTO } from '@interfaces/rent/dto/assetRentDTO';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_RENT_REQUEST_CARD_ITEMS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateAddItemToExistingAssetRentRequest = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();

	const { mutateAsync: addNewAssetToRequest } = useMutation<IAddItemToExistingAssetRentRequestDTO>({
		mutationKey: [
			ASSET_RENT_REQUEST_CARD_ITEMS,
			id,
		],
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetRentProposedDatesForItemSuccess,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}
		},
		mutationFn: (request: IAddItemToExistingAssetRentRequestDTO) => addItemToExistingAssetRentRequest(request),
	});

	return { addNewAssetToRequest };
};
